export const Languages = {
  EN: 'en',
  ES: 'es',
} as const;

export type LanguageT = (typeof Languages)[keyof typeof Languages];

export default {
  supportedLngs: Object.values(Languages),
  fallbackLng: Languages.EN,
  defaultNS: 'common',
  ns: [
    'common',
    'home',
    'about',
    'team',
    'services',
    'faq',
    'careers',
    'contact',
    'get-started',
    'resources',
    'locations',
    'legal',
    'cookies',
    'start',
    'checklist',
    'insurance',
  ],
  interpolation: {
    escapeValue: false,
  },
};
